/**
 * Shared overlay backdrop used by Modal, BottomSheet, and Drawer.
 *
 * Renders as `position: absolute` so it fills whatever fixed/relative stacking
 * container the parent overlay creates.  Carries `pointer-events-auto` so
 * clicks/taps don't fall through to the page below.
 *
 * Z-index: none by default — the parent overlay container owns the z-ladder
 * position (z-40 for Drawer's root, z-[70] for BottomSheet's root, etc.).
 * Pass a `className` to add a z-override when sibling ordering alone is
 * insufficient.
 */
export interface BackdropProps {
  /** Called when the user clicks/taps the backdrop. */
  onClick: () => void
  /** Additional Tailwind classes (e.g. z-override, custom opacity). */
  className?: string
}

export function Backdrop({ onClick, className = '' }: BackdropProps) {
  return (
    <div
      className={['absolute inset-0 bg-black/50 pointer-events-auto', className].filter(Boolean).join(' ')}
      aria-hidden="true"
      onClick={onClick}
    />
  )
}
